import { Layout } from "./Layout";
import { Behavior } from "../../base/Behavior";

export class LayoutBehavior extends Behavior {
    protected constructor() {
        super();
    }

    public setDeviceBehaviors(layout: Layout): void {
        // No additional web-specific behaviors defined
    }

    get type(): string {
        return "Layout";
    }
}

LayoutBehavior.register();
